module.exports = __webpack_public_path__ + "static/img/manual_ja_37.d94c020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_37.png
// module id = C8pW
// module chunks = 4